import {useEffect, useState} from "react";
import {Avatar, Box, Button, Divider, IconButton, Menu, Stack, Typography} from "@mui/material";

import {RemoveItem, GetItem} from "utils/storage";
import {StorageKey} from "constants/constants";
import {Link, useNavigate} from "react-router-dom";

const Profile = () => {
    const navigate = useNavigate();
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [getUser, setUser] = useState({email:'', fullname:''})
    const handleClick2 = (event) => {
        setAnchorEl2(event.currentTarget);
    };
    const handleClose2 = () => {
        setAnchorEl2(null);
    };
    useEffect(() => {
        async function fetchUserProfile() {
            const user = await GetItem(StorageKey.USER);
            setUser({
                email:user.email,
                fullname:user.fullname
            })
        }
        fetchUserProfile();
    }, [])

    const logout = async () => {
        await RemoveItem(StorageKey.TOKEN);
        await RemoveItem(StorageKey.USER);
        await RemoveItem(StorageKey.FORM_TYPE);
        setTimeout(() => {
            navigate('/');
        }, 1000);
    };

    return (
        <Box>
            <IconButton
                size="large"
                aria-label="show 11 new notifications"
                color="inherit"
                aria-controls="msgs-menu"
                aria-haspopup="true"
                sx={{
                    ...(typeof anchorEl2 === 'object' && {
                        color: 'primary.main',
                    }),
                }}
                onClick={handleClick2}
            >
                <Avatar
                    src={"/images/profile.svg"}
                    alt={'ProfileImg'}
                    sx={{
                        width: 40,
                        height: 40,
                    }}
                />
            </IconButton>
            <Menu
                id="msgs-menu"
                anchorEl={anchorEl2}
                keepMounted
                open={Boolean(anchorEl2)}
                onClose={handleClose2}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                sx={{
                    '& .MuiMenu-paper': {
                        width: '300px',
                        p: 4,
                    },
                }}
            >
                <Typography variant="h5">User Profile</Typography>
                <Stack direction="row" py={3} spacing={2} alignItems="center">
                    <Avatar src={"/images/profile.svg"} alt={"ProfileImg"} sx={{ width: 50, height: 50 }} />
                    <Box>
                        <Typography variant="subtitle2" color="textPrimary" fontWeight={600}>
                            {getUser.fullname} 
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                            {getUser.email} 
                        </Typography>
                    </Box>
                </Stack>
                <Divider />

                <Box mt={2}>
                    <Button onClick={logout} variant="outlined" color="primary" fullWidth>
                        Cerrar Sesión
                    </Button>
                </Box>
            </Menu>
        </Box>
    );
};

export default Profile;